import { render, staticRenderFns } from "./CrossAnagraphicLookup.vue?vue&type=template&id=2f64ce06&"
import script from "./CrossAnagraphicLookup.vue?vue&type=script&lang=ts&"
export * from "./CrossAnagraphicLookup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports